module.exports = __webpack_public_path__ + "img/modelo_small11.adb37c6d.png";